export default __webpack_public_path__ + "static/media/pg.4fe5e497.svg";